// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__12XM4","requiredAsterisk":"Info_requiredAsterisk__2Z_T1"};